import { render, staticRenderFns } from "./structure-card.vue?vue&type=template&id=75884f28&scoped=true"
import script from "./structure-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./structure-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./structure-card.vue?vue&type=style&index=0&id=75884f28&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75884f28",
  null
  
)

export default component.exports